export enum rolesDar {
  admin = 'admin_dar',
  gestionnaire = 'gestionnaire_dar',
  demandeur = 'demandeur_dar', // TODO ne semble pas être initialisé (et détectable par ailleurs)

  masse_salariale = 'masse_salariale_dar',
  sbtcp = 'sbtcp_dar',
  drh = 'drh_dar',

  commission = 'commission_dar',
  commission_consult = 'commission_consult_dar',

  spta = 'spta_dar',
  spta_traitement = 'spta_traitement_dar',

  spte = 'spte_dar',

  recrutement = 'recrutement_dar',
  recrutement_spte = 'recrutement_spte_dar',
  dvc = 'dvc_dar'
}


